import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import ReactMarkdown from "react-markdown";
import { isSafeInternalHref } from "@/utils/internalContentLinks";
interface MarkdownContentProps {
  id?: string;
  text: string;
  className?: string;
}

/**
 * Constrained renderer for admin-authored collection content. Raw HTML,
 * images, and external links are intentionally not rendered.
 */
export default function MarkdownContent(t0) {
  const $ = _c(10);
  const {
    id,
    text,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `t-space-y-3 ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.trim();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["p", "strong", "em", "ul", "ol", "li", "a", "br", "h2", "h3", "blockquote"];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      p: _temp,
      strong: _temp2,
      em: _temp3,
      ul: _temp4,
      ol: _temp5,
      li: _temp6,
      h2: _temp7,
      h3: _temp8,
      blockquote: _temp9,
      a: _temp10
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== text) {
    t6 = <ReactMarkdown skipHtml={true} allowedElements={t4} unwrapDisallowed={true} components={t5}>{text}</ReactMarkdown>;
    $[4] = text;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== id || $[7] !== t3 || $[8] !== t6) {
    t7 = <div id={id} className={t3}>{t6}</div>;
    $[6] = id;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp10(t0) {
  const {
    href,
    children: children_8
  } = t0;
  return href && isSafeInternalHref(href) ? <Link href={href} className="t-font-semibold t-text-automotive-primary t-underline t-decoration-2 t-underline-offset-2 hover:t-text-purple-800 focus:t-rounded-sm focus:t-outline-none focus:t-ring-2 focus:t-ring-automotive-primary focus:t-ring-offset-2">{children_8}</Link> : <span>{children_8}</span>;
}
function _temp9(t0) {
  const {
    children: children_7
  } = t0;
  return <blockquote className="t-my-0 t-border-l-4 t-border-automotive-primary/40 t-pl-4 t-italic">{children_7}</blockquote>;
}
function _temp8(t0) {
  const {
    children: children_6
  } = t0;
  return <h4 className="t-m-0 t-pt-1 t-text-base t-font-bold t-text-automotive-dark">{children_6}</h4>;
}
function _temp7(t0) {
  const {
    children: children_5
  } = t0;
  return <h3 className="t-m-0 t-pt-2 t-text-lg t-font-bold t-text-automotive-dark">{children_5}</h3>;
}
function _temp6(t0) {
  const {
    children: children_4
  } = t0;
  return <li className="t-pl-1">{children_4}</li>;
}
function _temp5(t0) {
  const {
    children: children_3
  } = t0;
  return <ol className="t-my-0 t-list-decimal t-space-y-1 t-pl-6">{children_3}</ol>;
}
function _temp4(t0) {
  const {
    children: children_2
  } = t0;
  return <ul className="t-my-0 t-list-disc t-space-y-1 t-pl-6">{children_2}</ul>;
}
function _temp3(t0) {
  const {
    children: children_1
  } = t0;
  return <em>{children_1}</em>;
}
function _temp2(t0) {
  const {
    children: children_0
  } = t0;
  return <strong className="t-font-bold">{children_0}</strong>;
}
function _temp(t0) {
  const {
    children
  } = t0;
  return <p className="t-m-0">{children}</p>;
}